import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';
import ChannelAppResource from './ChannelAppResource';
import FileTagAppResource from './FileTagAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PropertyAppResource from './PropertyAppResource';
import PropertyInstanceAppResource from './PropertyInstanceAppResource';
import StageAppResource from './StageAppResource';
import UserAppResource from './UserAppResource';
import WildAppResource from './WildAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import WorkspaceOrganizationMemberAppResource
    from './WorkspaceOrganizationMemberAppResource';
import {objectToFormData} from 'object-to-formdata';
import isEmpty from 'lodash/isEmpty';
import FolderAppResource from "./FolderAppResource";
import DocumentTagAppResource from "./DocumentTagAppResource";

class FileAppResource extends AppResource {

    constructor(data, fetched = false) {
        super(data, fetched);
        this.validationFilePresence = true;
        this.initOnceHeaders();
    }

    initOnceHeaders() {
        this.additionalOnceHeaders = {};
    }

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'File';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'files';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'public',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'file',
            'fileTitle',
            'fileDescription',
            'fileName',
            'fileType',
            'fileExtension',
            'uploaderUser',
            'uploaderUserUuid',
            'workspaceOrganizationMembers',
            'links',
            'messageAttachments',
            'users',
            'tags',
            'emoticons',
            'organizations',
            'workspaces',
            'stages',
            'channels',
            'properties',
            'propertyInstances',
            'businessProfiles',
            'organization',
            'organizationUuid',
            'workspaceUuid',
            'stageUuid',
            'channelUuid',
            'public',
            'folderUuid',
            'documentTags',
            'expiresAt',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            uploaderUser: UserAppResource,
            workspaceOrganizationMembers: WorkspaceOrganizationMemberAppResource,
            links: WildAppResource,
            messageAttachments: WildAppResource,
            users: UserAppResource,
            tags: FileTagAppResource,
            emoticons: WildAppResource,
            organizations: OrganizationAppResource,
            organization: OrganizationAppResource,
            workspaces: WorkspaceAppResource,
            workspace: WorkspaceAppResource,
            stages: StageAppResource,
            stage: StageAppResource,
            channels: ChannelAppResource,
            channel: ChannelAppResource,
            properties: PropertyAppResource,
            propertyInstances: PropertyInstanceAppResource,
            businessProfiles: BusinessProfileAppResource,
            folder: FolderAppResource,
            documentTags: DocumentTagAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            uploaderUser: 'uploader_user_uuid',
            organization: 'organization_uuid',
            workspace: 'workspace_uuid',
            stage: 'stage_uuid',
            channel: 'channel_uuid',
            folder: 'folder_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        let rules = {
            includeDownloadUrl: {
                type: 'string',
            },
            file: {
                type: 'object',
            },
            fileTitle: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            fileDescription: {
                type: 'string',
                length: {
                    minimum: 1,
                },
            },
            organizationUuid: {
                type: 'string',
            },
            workspaceUuid: {
                type: 'string',
            },
            stageUuid: {
                type: 'string',
            },
            channelUuid: {
                type: 'string',
            },
            propertyUuid: {
                type: 'string',
            },
            uploaderUserUuid: {
                type: 'string',
            },
            propertyInstanceUuid: {
                type: 'string',
            },
            public: {
                type: 'boolean',
            },
            folderUuid: {
                type: 'string',
            },
        };

        if (!this.exists && this.validationFilePresence) {
            rules.file.presence = true;
        }

        return rules;
    }

    setOnceHeaders(headers) {
        this.additionalOnceHeaders = headers;
    }

    async enginePost(url, data, config = {}) {
        let additionalHeaders = {};

        if (data.file && !(data instanceof FormData)) {
            data = objectToFormData(data);
            additionalHeaders['Content-Type'] = 'multipart/form-data';
        }

        if (data instanceof FormData && !isEmpty(this.meta)) {
            if (!url.includes('?')) {
                url = url + '?';
            }
            if (!url.includes('meta=')) {
                url = url + 'meta=' + JSON.stringify(this.meta);
            }
            url = encodeURI(url);
        }

        try {
            const r = super.enginePost(url, data, {
                ...config,
                headers: {
                    ...config.headers,
                    ...this.additionalOnceHeaders,
                    ...additionalHeaders,
                },
            });
            this.initOnceHeaders();
            return r;
        } catch (e) {
            this.initOnceHeaders();
            throw e;
        }
    }
}

export default FileAppResource;
